import axios from 'axios'
import {
  IBoardCaseFilter,
  IBoardCasePostModel,
  ICasePutDecisionModel,
  ICasePutModel,
} from '../models/BoardCase'

const BASE_URL = 'boardmeetings/cases'

const defaultConfig = {
  headers: {
    'x-api-version': '1.0',
  },
}

export const getBoardCasesApi = (body: IBoardCaseFilter) =>
  axios.post(`${BASE_URL}/query`, body)

export const getCase = (caseId: string) =>
  axios.get(`${BASE_URL}/${caseId}`, defaultConfig)

export const createBoardCase = (model: IBoardCasePostModel) =>
  axios.post(BASE_URL, model, defaultConfig)

export const updateBoardCase = (model: ICasePutModel, caseId: string) =>
  axios.put(`${BASE_URL}/${caseId}`, model, defaultConfig)

export const sendCaseDescription = (
  caseId: string,
  body: ICasePutDecisionModel
) => axios.put(`${BASE_URL}/${caseId}/description`, body, defaultConfig)

export const sendCaseSuggestedDecision = (
  caseId: string,
  body: ICasePutDecisionModel
) => axios.put(`${BASE_URL}/${caseId}/suggesteddecision`, body, defaultConfig)
